import { render, staticRenderFns } from "./loadingBlock.vue?vue&type=template&id=d6005682&"
import script from "./loadingBlock.vue?vue&type=script&lang=js&"
export * from "./loadingBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports